import Vue from "vue";
import SalaryInfoModalHeader from "../SalaryInfoModalHeader.vue";
import AdditionsTable from "./AdditionsTable.vue";
export default Vue.extend({
    props: {
        selectedDate: String,
        fullName: String,
        salaryRow: {},
    },
    components: {
        SalaryInfoModalHeader,
        AdditionsTable,
    },
});
